import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { currentPageReportTemplate, onPageChange, paginatorTemplate, rowsPerPageOptions } from "../../../utilities/TableUtil";
import { normalColumn } from "../../../components/DataTable/DataTable.js";
import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";

export default function P115List_1({ dataTable, goBack }) {
    const [globalFilter] = useState(null);
    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });

    const header = (
        <div className="table-header" style={{ padding: "2px" }}>
            <div>
                <Button
                    className="p-button-secondary p-button btn-hidden-responsive"
                    icon="pi pi-arrow-left"
                    label="กลับหน้าจอหลัก"
                    // style={{ width: 150, marginLeft: '5px' }}
                    onClick={() => goBack()}
                />
            </div>
        </div>
    );

    return (
        <div className="datatable-responsive-modify">
            <div className="card">
                <DataTable
                    header={header}
                    value={dataTable}
                    dataKey="id"
                    paginator
                    first={pageConf.first}
                    rows={pageConf.rows}
                    onPage={(e) => onPageChange(e, setPageConf)}
                    rowsPerPageOptions={rowsPerPageOptions()}
                    paginatorTemplate={paginatorTemplate()}
                    currentPageReportTemplate={currentPageReportTemplate()}
                    globalFilter={globalFilter}
                    emptyMessage="ไม่พบข้อมูล"
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                    selectionMode="single"
                >
                    <Column field="seq" header="ลำดับที่" body={(e) => normalColumn(e, "seq", "ลำดับที่")} style={{ textAlign: "center", width: "3%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="requestStatus" header="สถานะ" body={(e) => normalColumn(e, "requestStatus", "สถานะ")} style={{ textAlign: "center", width: "8%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="updateUserName" header="ผู้บันทึกแก้ไข" body={(e) => normalColumn(e, "updateUserName", "ผู้บันทึกแก้ไข")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="updateDt" header="วันที่-เวลา" body={(e) => normalColumn(e, "updateDt", "วันที่-เวลา")} style={{ textAlign: "center", width: "8%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="remark" header="หมายเหตุ" body={(e) => normalColumn(e, "remark", "หมายเหตุ")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                </DataTable>
            </div>
        </div>
    );
}
